export const templateSessionFilial = (dataSession) => {
	const mailTemplateSesionConsejoAdmin =
		`<div style="text-align:justify;">
		<p><strong>#usuario#,</strong></p>

		<br>

		<p>La sesión <strong><a href="` +
		`${window.location.href}?type=filial` +
		`" target="_blank" style="color: rgb(0,0,0);">` +
		dataSession.numero_sesion +
		`</a></strong> del órgano colegiado <strong>` +
		dataSession.nameOrgan +
		`</strong> ha sido publicada, para consultarla haga click.</p>
		<br>
		<br>
		<b>Atentamente</b>
		<br>
		<br>
		<strong>Marcos M. Herrería Alamina</strong>
		<br>
		<strong>Consejero Secretario</strong>
		</div>
		`;

	const mailTemplateSessionFilial =
		`<div style="text-align:justify;">
		<p><strong>#usuario#,</strong></p>

		<br>

		<p>La sesión <strong><a href="` +
		`${window.location.href}?type=filial` +
		`" target="_blank" style="color: rgb(0,0,0);">` +
		dataSession.numero_sesion +
		`</a></strong> del órgano colegiado <strong>` +
		dataSession.nameOrgan +
		`</strong> ha sido publicada, para consultarla haga click.</p>
		<br>
		<br>
		<b>Atentamente</b>
		<br>
		<br>
		<strong>Mayra Chim Kantún</strong>
		<br>
		<strong>Secretaria</strong>
		</div>
		`;

	return dataSession.nameOrgan === 'Consejo de Administración'
		? mailTemplateSesionConsejoAdmin
		: mailTemplateSessionFilial;
};
